import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyClp',
  standalone: true
})
export class CurrencyClpPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (value == null) return '$0';
    
    return formatCurrencyInput(value.toString());
  }
}

export function parseCurrencyClp(value: string): number {
  return parseInt(value.replace(/[^\d]/g, ''), 10) || 0;
}

export function formatCurrencyInput(value: string ): string {
  const numericValue = parseCurrencyClp(value);
  return new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP',
    maximumFractionDigits: 0
  }).format(numericValue);
}